<template>
    <div class="travel-quote-step select-where">
        <quote-step-header
            :title="subStepFields.title"
            :key="currentSubStep"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center">
                <div
                    v-for="i in numberOfDestinations"
                    :key="i"
                    class="travel-where-destination flex items-center gap-2"
                >
                    <app-autocomplete-input
                        class="w-full"
                        label="quote.travel.destination.choose_destination"
                        v-model="destination[i-1]"
                        :search-cb="searchCountries"
                        :placeholder="trans('choose')"
                    >
                    </app-autocomplete-input>
                    <span
                        v-if="i > 1"
                        v-html="$icon('remove')"
                        class="relative top-2 cursor-pointer"
                        @click="removeDestination"
                    ></span>
                </div>
                <plus-button
                    v-if="numberOfDestinations < 3"
                    @click="addDestination"
                    :label="trans('add_extra_destination')"
                >
                </plus-button>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppAutocompleteInput from "../../Forms/AutocomplateInput";
import PlusButton from "../../Forms/PlusButton.vue";
import icons from "../../../icons";
import debounce from "lodash.debounce";

export default {
    name: "TravelQuoteSelectWhere",
    components: { AppAutocompleteInput, PlusButton },
    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"],
            numberOfDestinations: 1,
            icons,
            destination: []
        };
    },

    watch: {
        destination() {
            this.destination.forEach((destination, i) => {
                this.form[this.stepName].destination[i] = destination.value
            })
        }
    },

    computed: {
        canMoveNext() {
            const destination = this.destination;
            if (!destination || destination.length < this.numberOfDestinations)
                return false;
            return destination.reduce(
                (valid, currentDestination) => valid && currentDestination
            );
        }
    },

    methods: {
        searchCountries: async function(term) {
            if (!term || term.length < 2) return;

            const res = await this.$api.get("countries/search?q=" + term);
            const items = res.data();
            return items.map(({ id, heb_name }) => ({
                value: id,
                label: heb_name
            }));
        }, // 500 milliseconds debounce time
        addDestination() {
            this.numberOfDestinations = this.numberOfDestinations + 1;
        },
        removeDestination() {
            this.numberOfDestinations = this.numberOfDestinations - 1;
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-form .form-row {
    align-items: flex-start;
}

.select-where {
    position: relative;

    .step-header {
        .icon {
            width: 135px;
            height: 135px;
        }
    }

    .submit-row {
        margin-top: 40px !important;
    }

    .travel-where-destination {
        width: 100%;

        .travel-where-info {
            width: 20%;
            font-size: 17px;
            font-weight: bold;
            line-height: 1.76;
            text-align: center;
            color: $black;
            display: flex;
            border-right: 1px solid $medium-gray;
            align-items: center;
            justify-content: center;
            padding-right: 40px;
        }
    }

    .app-quote-text-radio-buttons {
        flex: 1;

        .text-radio-buttons-wrap {
            flex-wrap: wrap;

            label {
                flex: 0 33.3%;
                margin: 0;
                margin-bottom: 30px;

                .text-radio-buttons-circle {
                    width: 113px;
                    height: 114px;
                }

                .label {
                    font-size: 18px;
                    font-weight: $font-light;
                    line-height: 1.28;
                    color: $black;
                }
            }
        }
    }
}

.add-destination {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #185af5;
    cursor: pointer;

    .icon {
        width: 40px;
        height: 40px;

        svg {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
